// extracted by mini-css-extract-plugin
module.exports = {"root":"sectionTitle_root__1bl5Y","padding":"sectionTitle_padding__1CRF6","title":"sectionTitle_title__3IMo1","small":"sectionTitle_small__b4NmQ"};